import React from 'react';
import { useRouter } from 'next/router';
import * as S from './VipAndLatestAds.styles';
import { VipAndLatestAdsSkeletonLoader } from './VipAndLatestAdsSkeletonLoader';
import { VipAndLatestAdsWithInfiniteScroll } from '@/components/AdsWithInfiniteScroll/VipAndLatestAdsWithInfiniteScroll';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { useServerDataContext } from '@/contexts';
import { DesktopFilters } from '@/components/Filters/DesktopFilters';
import { useResponsive } from '@/hooks/useResponsive';
import { SortSelector } from '@/components/Filters/SortSelector';
import { useParseQuery } from '@/hooks/useParseQuery/useParseQuery';
import { AdOrder } from '@/api/types/ads.types';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { QUERY } from '@/constants/common';
import NoSsr from '@/components/NoSsr/NoSsr';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

interface VipAndLatestAdsProps {
  onPaginationChange?: (hasNextPage: boolean) => void;
}

export const VipAndLatestAds = ({
  onPaginationChange,
}: VipAndLatestAdsProps = {}) => {
  const router = useRouter();
  const { currentCategory: serverCurrentCategory } = useServerDataContext();
  const { currentCategory = serverCurrentCategory } = useCurrentCategory();
  const { isDesktop } = useResponsive();
  const { order } = useParseQuery();

  if (!currentCategory?.id) {
    return <VipAndLatestAdsSkeletonLoader />;
  }

  function handleChangeOrder(newOrder: AdOrder) {
    const { pathname, query } = router;
    router.push({
      pathname,
      query: {
        ...query,
        order: newOrder.toLowerCase(),
        [QUERY.keywords_source]: KeywordsSource.Typewritten,
      },
    });
  }

  if (isDesktop) {
    return (
      <S.Wrapper>
        <DesktopFilters />
        <S.AdsListContainer>
          <NoSsr
            fallback={
              <SkeletonLoader width={225} height={45} borderRadius={14} />
            }
          >
            <SortSelector value={order} onChange={handleChangeOrder} />
          </NoSsr>
          <VipAndLatestAdsWithInfiniteScroll
            onPaginationChange={onPaginationChange}
          />
        </S.AdsListContainer>
      </S.Wrapper>
    );
  }

  return (
    <VipAndLatestAdsWithInfiniteScroll
      onPaginationChange={onPaginationChange}
    />
  );
};
